import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService } from './toast.service';
import { ToastComponent } from './toast/toast.component';

@Component({
    selector: 'nexus-toast-container',
    imports: [AsyncPipe, ToastComponent],
    templateUrl: './toast-container.component.html',
    styleUrl: './toast-container.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastContainerComponent {
  service = inject(ToastService);

  toasts$ = this.service.getToasts();

  remove(id: string) {
    this.service.hide(id);
  }
}
